import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddProcedure } from 'src/app/types/procedure/add-procedure.type';
import { Procedure, Procedures } from 'src/app/types/procedure/procedure.type';
import { HttpService } from '../http-service.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService extends HttpService {

  constructor(private _httpClient: HttpClient) {
    super('procedure')
  }

  exists(procedure: AddProcedure): Observable<void> {
    return this._httpClient.head<void>(`${this.url}/validate-description?description=${procedure.description}`)
  }

  add(procedure: AddProcedure): Observable<number> {
    return this._httpClient.post<number>(this.url, { procedure })
  }

  get(procedureId: number): Observable<Procedure> {
    return this._httpClient.get<Procedure>(`${this.url}/${procedureId}`)
  }

  getAll(filter?): Observable<Procedures> {
    let url: string = this.url
    if (filter) {
      url += this.implementQueries(filter)
    }
    return this._httpClient.get<Procedures>(url)
  }

  edit(procedure: Procedure): Observable<number> {
    return this._httpClient.put<number>(`${this.url}/${procedure.id}`, { procedure: { description: procedure.description, modalityId: procedure.modalityId } })
  }

  delete(procedureId: number): Observable<number> {
    return this._httpClient.delete<number>(`${this.url}/${procedureId}`)
  }
}